export const LAYERS = [
  { key: "strategy", label: "Strategy" },
  { key: "business", label: "Business" },
  { key: "application", label: "Application" },
  { key: "technology", label: "Technology" },
  { key: "motivation", label: "Motivation" },
  { key: "implementation_migration", label: "Implementation & Migration" },
  { key: "other", label: "Other" },
];

export const LAYER_COLORS = {
  strategy: { bg: "#E0E7FF", border: "#6366F1", text: "#312E81", badge: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  business: { bg: "#FEF9C3", border: "#EAB308", text: "#713F12", badge: "bg-amber-100 text-amber-800 border-amber-300" },
  application: { bg: "#E0F2FE", border: "#0284C7", text: "#0C4A6E", badge: "bg-sky-100 text-sky-800 border-sky-300" },
  technology: { bg: "#DCFCE7", border: "#16A34A", text: "#14532D", badge: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  motivation: { bg: "#F3E8FF", border: "#A855F7", text: "#581C87", badge: "bg-purple-100 text-purple-800 border-purple-300" },
  implementation_migration: { bg: "#FFE4E6", border: "#E11D48", text: "#881337", badge: "bg-rose-100 text-rose-800 border-rose-300" },
  other: { bg: "#F1F5F9", border: "#64748B", text: "#334155", badge: "bg-slate-100 text-slate-700 border-slate-300" },
};

export const ELEMENT_TYPES = {
  resource: { label: "Resource", layer: "strategy", icon: "Wallet" },
  capability: { label: "Capability", layer: "strategy", icon: "Rocket" },
  "course-of-action": { label: "Course of Action", layer: "strategy", icon: "Signpost" },
  "value-stream": { label: "Value Stream", layer: "strategy", icon: "Waves" },

  "business-actor": { label: "Business Actor", layer: "business", icon: "User" },
  "business-role": { label: "Business Role", layer: "business", icon: "UserCog" },
  "business-collaboration": { label: "Business Collaboration", layer: "business", icon: "Users" },
  "business-interface": { label: "Business Interface", layer: "business", icon: "Plug" },
  "business-process": { label: "Business Process", layer: "business", icon: "Workflow" },
  "business-function": { label: "Business Function", layer: "business", icon: "Cog" },
  "business-interaction": { label: "Business Interaction", layer: "business", icon: "ArrowLeftRight" },
  "business-event": { label: "Business Event", layer: "business", icon: "Zap" },
  "business-service": { label: "Business Service", layer: "business", icon: "Circle" },
  "business-object": { label: "Business Object", layer: "business", icon: "FileText" },
  contract: { label: "Contract", layer: "business", icon: "FileSignature" },
  representation: { label: "Representation", layer: "business", icon: "ScrollText" },
  product: { label: "Product", layer: "business", icon: "Package" },

  "application-component": { label: "Application Component", layer: "application", icon: "Box" },
  "application-collaboration": { label: "Application Collaboration", layer: "application", icon: "Users" },
  "application-interface": { label: "Application Interface", layer: "application", icon: "Plug" },
  "application-function": { label: "Application Function", layer: "application", icon: "Cog" },
  "application-interaction": { label: "Application Interaction", layer: "application", icon: "ArrowLeftRight" },
  "application-process": { label: "Application Process", layer: "application", icon: "Workflow" },
  "application-event": { label: "Application Event", layer: "application", icon: "Zap" },
  "application-service": { label: "Application Service", layer: "application", icon: "Circle" },
  "data-object": { label: "Data Object", layer: "application", icon: "Database" },

  node: { label: "Node", layer: "technology", icon: "Server" },
  device: { label: "Device", layer: "technology", icon: "HardDrive" },
  "system-software": { label: "System Software", layer: "technology", icon: "Cpu" },
  "technology-collaboration": { label: "Technology Collaboration", layer: "technology", icon: "Users" },
  "technology-interface": { label: "Technology Interface", layer: "technology", icon: "Plug" },
  path: { label: "Path", layer: "technology", icon: "Route" },
  "communication-network": { label: "Communication Network", layer: "technology", icon: "Network" },
  "technology-function": { label: "Technology Function", layer: "technology", icon: "Cog" },
  "technology-process": { label: "Technology Process", layer: "technology", icon: "Workflow" },
  "technology-interaction": { label: "Technology Interaction", layer: "technology", icon: "ArrowLeftRight" },
  "technology-event": { label: "Technology Event", layer: "technology", icon: "Zap" },
  "technology-service": { label: "Technology Service", layer: "technology", icon: "Circle" },
  artifact: { label: "Artifact", layer: "technology", icon: "FileBox" },

  stakeholder: { label: "Stakeholder", layer: "motivation", icon: "UserCheck" },
  driver: { label: "Driver", layer: "motivation", icon: "Gauge" },
  assessment: { label: "Assessment", layer: "motivation", icon: "ClipboardCheck" },
  goal: { label: "Goal", layer: "motivation", icon: "Target" },
  outcome: { label: "Outcome", layer: "motivation", icon: "Trophy" },
  principle: { label: "Principle", layer: "motivation", icon: "Compass" },
  requirement: { label: "Requirement", layer: "motivation", icon: "ListChecks" },
  constraint: { label: "Constraint", layer: "motivation", icon: "Lock" },
  meaning: { label: "Meaning", layer: "motivation", icon: "MessageSquare" },
  value: { label: "Value", layer: "motivation", icon: "Gem" },

  "work-package": { label: "Work Package", layer: "implementation_migration", icon: "Briefcase" },
  deliverable: { label: "Deliverable", layer: "implementation_migration", icon: "PackageCheck" },
  "implementation-event": { label: "Implementation Event", layer: "implementation_migration", icon: "Zap" },
  plateau: { label: "Plateau", layer: "implementation_migration", icon: "Mountain" },
  gap: { label: "Gap", layer: "implementation_migration", icon: "AlertTriangle" },

  grouping: { label: "Grouping", layer: "other", icon: "Group" },
};

export const RELATIONSHIP_TYPES = {
  composition: { label: "Composition", dash: "0", markerStart: "diamond-filled" },
  aggregation: { label: "Aggregation", dash: "0", markerStart: "diamond-hollow" },
  assignment: { label: "Assignment", dash: "0", markerStart: "circle-filled", markerEnd: "arrow-filled-sm" },
  realization: { label: "Realization", dash: "6,4", markerEnd: "triangle-hollow" },
  serving: { label: "Serving", dash: "0", markerEnd: "arrow-open" },
  access: { label: "Access", dash: "2,3", markerEnd: "arrow-open-sm" },
  influence: { label: "Influence", dash: "6,4", markerEnd: "arrow-open" },
  triggering: { label: "Triggering", dash: "0", markerEnd: "triangle-filled" },
  flow: { label: "Flow", dash: "6,4", markerEnd: "triangle-filled" },
  specialization: { label: "Specialization", dash: "0", markerEnd: "triangle-hollow" },
  association: { label: "Association", dash: "0" },
};

export const RELATIONSHIP_PHRASES = {
  composition: "is composed of",
  aggregation: "aggregates",
  assignment: "is assigned to",
  realization: "realizes",
  serving: "serves",
  access: "accesses",
  influence: "influences",
  triggering: "triggers",
  flow: "flows to",
  specialization: "is a specialization of",
  association: "is associated with",
};

export function buildRelationshipSentence(relType, sourceName, targetName, customLabel) {
  const phrase = RELATIONSHIP_PHRASES[relType] || "is related to";
  let sentence = `${sourceName} ${phrase} ${targetName}`;
  if (customLabel) sentence += ` \u2014 ${customLabel}`;
  return `${sentence}.`;
}

export const STATUS_OPTIONS = ["Dev", "Test", "Live", "Retired"];
export const RELEASE_CANDIDATE_OPTIONS = ["R1", "R2", "R3", "R4", "R5"];

export const STATUS_COLORS = {
  Dev: { dot: "#94A3B8", ring: "#64748B", label: "Dev" },
  Test: { dot: "#F59E0B", ring: "#B45309", label: "Test" },
  Live: { dot: "#10B981", ring: "#047857", label: "Live" },
  Retired: { dot: "#EF4444", ring: "#B91C1C", label: "Retired" },
};

export const RELEASE_CANDIDATE_COLORS = {
  Unset: { dot: "#CBD5E1", label: "Unset" },
  R1: { dot: "#3B82F6", label: "R1" },
  R2: { dot: "#8B5CF6", label: "R2" },
  R3: { dot: "#14B8A6", label: "R3" },
  R4: { dot: "#F59E0B", label: "R4" },
  R5: { dot: "#EC4899", label: "R5" },
};

export const SIMPLE_CATEGORIES = ["User", "Process", "System", "Data", "Infrastructure", "Other"];

export const SIMPLE_CATEGORY_COLORS = {
  User: { bg: "#EDE9FE", border: "#8B5CF6", text: "#4C1D95", icon: "User" },
  Process: { bg: "#DBEAFE", border: "#3B82F6", text: "#1E3A8A", icon: "Workflow" },
  System: { bg: "#D1FAE5", border: "#10B981", text: "#064E3B", icon: "Box" },
  Data: { bg: "#FEF3C7", border: "#F59E0B", text: "#78350F", icon: "Database" },
  Infrastructure: { bg: "#E2E8F0", border: "#64748B", text: "#1E293B", icon: "Server" },
  Other: { bg: "#FCE7F3", border: "#EC4899", text: "#831843", icon: "Circle" },
};
